export default "__VITE_ASSET__EdJ0tAIR__"